export const SHARED_SOURCING_STEPS = [
  'SELECTED_CANDIDATES',
  'CHOOSE_CHANNEL',
  'JOB_INFORMATION',
  'SETUP_APPLICATION',
  'CUSTOMIZE_MESSAGE',
  'REVIEW_INVITATIONS',
  'SUCCESS'
] as const;
